export default __webpack_public_path__ + "static/media/Vector.52f58146.svg";